import { render } from "./CartSuveniri.vue?vue&type=template&id=505f5970&scoped=true"
import script from "./CartSuveniri.vue?vue&type=script&lang=js"
export * from "./CartSuveniri.vue?vue&type=script&lang=js"

import "./CartSuveniri.vue?vue&type=style&index=0&id=505f5970&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505f5970"]])

export default __exports__